import { render, staticRenderFns } from "./work-imgs-overlay.vue?vue&type=template&id=00cff80d"
import script from "./work-imgs-overlay.vue?vue&type=script&lang=js"
export * from "./work-imgs-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports